/**
 * 优惠券管理
 */

import {
  CouponBizGroupType,
  CouponCDKeyGenerateMethod,
  CouponStatus,
  CouponStatusModifyType,
  DialogType
} from '@/config'
import { parsePayloadJsonData } from '@/utils'

import { cdKeyExportDialog } from './_cdkey'
import { addEditDialog } from './_couponDialog'
import dayjs from "dayjs";

export default {
  body: {
    type: 'crud',

    actions: {
      query: {
        api: {
          url: 'admin/coupon/queryCouponListPage',
          responseTransform: (res: any) => {
            res.data = (res.data || []).map((it: any) => {
              parsePayloadJsonData(it)
              return it
            })
            return res
          }
        }
      },
      add: { api: 'admin/coupon/saveCouponInfo', dialog: addEditDialog() },
      detail: { dialog: addEditDialog(DialogType.VIEW) },
      revoke: {
        api: 'admin/coupon/modifyCouponStatus',
        payload: { couponCode: '${data.row.couponCode}', modifyType: CouponStatusModifyType.REVOKE },
        message: '撤回后，用户所有该类型优惠券立即失效。是否确定撤回？'
      },
      close: {
        api: 'admin/coupon/modifyCouponStatus',
        payload: { couponCode: '${data.row.couponCode}', modifyType: CouponStatusModifyType.CLOSE },
        message: '是否确定下架？'
      },
      exportCDKeys: {
        dialog: cdKeyExportDialog(CouponBizGroupType.COUPON)
      }
    },

    search: {
      labelWidth: 80,
      items: [
        { label: '券ID', type: 'input', prop: 'couponCode' },
        { label: '券名称', type: 'input', prop: 'couponName' },
        // { label: '发放类型', type: 'select', prop: 'grantType', options: 'couponGrantType' },
        { label: '券类型', type: 'select', prop: 'couponType', options: 'couponType' }
      ]
    },

    toolbar: {
      items: [{ action: 'add', label: '新增优惠券' }]
    },

    table: {
      operation: {
        width: 150,
        items: [
          { action: 'revoke', label: '撤销', visibleOn: `this.data.row.status === ${CouponStatus.NORMAL}` },
          { action: 'close', label: '下架', visibleOn: `this.data.row.status === ${CouponStatus.NORMAL}` },
          { action: 'detail' },
        ]
      },

      columns: [
        { label: '劵ID', prop: 'couponCode', minWidth: 180 },
        { label: '券名称', prop: 'couponName', minWidth: 150 },
        { label: '优惠方式', prop: 'couponTypeName', minWidth: 150 },
        // { label: '领取时间', prop: 'gmtModified', minWidth: 120,
        //   formatter: (row: any) => {
        //     const date = dayjs(row.gmtModified)
        //     return date.format('YYYY-MM-DD HH:mm:ss')
        //   }
        // },
        { label: '创建时间', prop: 'gmtCreate', minWidth: 150 ,
          formatter: (row: any) => {
            const date = dayjs(row.gmtCreate)
            return date.format('YYYY-MM-DD HH:mm:ss')
          }
        },
        { label: '券状态', prop: 'statusName', minWidth: 120 },
        { label: '领取数量', prop: 'receivedCount', minWidth: 120 },
        { label: '核销数量', prop: 'writtenOffCount', minWidth: 120 },
      ]
    }
  }
}
